(function () {
  'use strict';
  if (window.sscSizeChart) return;

  // between: which way to go when a waist falls between two sizes (the size guide's finder); default 'down'.
  window.sscSizeChartData = {
    'Anime Mesh Shorts': {
      measurements: ['Waist', 'Inseam', 'Length'], unit: 'inches',
      note: 'Unisex fit. If you are between two sizes, go for the smaller one.',
      sizes: { 'X-Small': ['23-26','5.0','15'], 'Small': ['27-30','5.5','16'], 'Medium': ['31-33','5.5','17'], 'Large': ['34-37','5.7','18'], 'X-Large': ['38-41','6','19'], '2X-Large': ['42-45','6','20'], '3X-Large': ['46-49','6.5','21'] }
    },
    'Basic Mesh Shorts': {
      measurements: ['Waist', 'Inseam', 'Length'], unit: 'inches',
      note: 'Unisex fit. If you are between two sizes, go for the smaller one.',
      sizes: { 'X-Small': ['23-26','5.0','15'], 'Small': ['27-30','5.5','16'], 'Medium': ['31-33','5.5','17'], 'Large': ['34-37','5.7','18'], 'X-Large': ['38-41','6','19'], '2X-Large': ['42-45','6','20'], '3X-Large': ['46-49','6.5','21'] }
    },
    'Retro Mesh Shorts': {
      measurements: ['Waist', 'Inseam', 'Length'], unit: 'inches',
      note: 'Unisex fit. If you are between two sizes, go for the smaller one.',
      sizes: { 'X-Small': ['23-26','5.0','15'], 'Small': ['27-30','5.5','16'], 'Medium': ['31-33','5.5','17'], 'Large': ['34-37','5.7','18'], 'X-Large': ['38-41','6','19'], '2X-Large': ['42-45','6','20'], '3X-Large': ['46-49','6.5','21'] }
    },
    'Distress Patch Ultimate Mesh Shorts': {
      measurements: ['Waist', 'Inseam', 'Outseam'], unit: 'inches',
      note: "Based on Ultimate Mesh Shorts fit. Slightly less stretchy due to double-lined mesh. If you're between two sizes, size up.", between: 'up',
      sizes: { 'X-Small': ['22-25','5.0','15'], 'Small': ['26-29','5.5','16'], 'Medium': ['30-32','5.5','17'], 'Large': ['33-36','6','18'], 'X-Large': ['37-40','6.5','19'], '2X-Large': ['41-44','7','20'], '3X-Large': ['45-48','7.5','21'] }
    },
    'Reversible Mesh Shorts': {
      measurements: ['Waist', 'Inseam', 'Length'], unit: 'inches',
      note: 'Runs a bit larger. If you are between two sizes, go for the smaller one.',
      sizes: { 'X-Small': ['23-26','5.0','15'], 'Small': ['27-30','5.5','16'], 'Medium': ['31-33','5.5','17'], 'Large': ['34-37','5.7','18'], 'X-Large': ['38-41','6','19'], '2X-Large': ['42-45','6','20'], '3X-Large': ['46-49','6.5','21'] }
    },
    'Ultimate Mesh Shorts': {
      measurements: ['Waist', 'Inseam', 'Outseam'], unit: 'inches',
      note: "Slightly less stretchy due to double-lined mesh. If you're between two sizes, size up.", between: 'up',
      sizes: { 'X-Small': ['22-25','5.0','15'], 'Small': ['26-29','5.5','16'], 'Medium': ['30-32','5.5','17'], 'Large': ['33-36','6','18'], 'X-Large': ['37-40','6.5','19'], '2X-Large': ['41-44','7','20'], '3X-Large': ['45-48','7.5','21'] }
    },
    'Board Shorts': {
      measurements: ['Waist', 'Inseam', 'Length'], unit: 'inches',
      note: 'Fits true to size.',
      sizes: { 'X-Small': ['23-25','4.5','14'], 'Small': ['26-29','5.0','15'], 'Medium': ['30-33','5.0','16'], 'Large': ['34-37','5.0','16.5'], 'X-Large': ['38-41','5.5','17'], '2X-Large': ['42-45','5.5','17.5'], '3X-Large': ['46-49','5.5','18'] }
    },
    '2 in 1 Lined Shorts': {
      measurements: ['Waist', 'Length', 'Hip Width', 'Leg Opening'], unit: 'inches',
      sizes: { 'X-Small': ['26-28','13','37','11.5'], 'Small': ['28-30','13.5','39','12'], 'Medium': ['30-32','14','41','12.5'], 'Large': ['32-34','15','43','13.5'], 'X-Large': ['34-36','15.5','44','14'], '2X-Large': ['36-38','16','45','14.5'], '3X-Large': ['38-40','16.5','46','15'] }
    },
    'Muay Thai Shorts': {
      measurements: ['Waist', 'Length', 'Hip Width', 'Leg Opening'], unit: 'inches',
      sizes: { 'X-Small': ['26-28','13','37','11.5'], 'Small': ['28-30','13.5','39','12'], 'Medium': ['30-32','14','41','12.5'], 'Large': ['32-34','15','43','13.5'], 'X-Large': ['34-36','15.5','44','14'], '2X-Large': ['36-38','16','45','14.5'], '3X-Large': ['38-40','16.5','46','15'] }
    },
    'Performance Joggers': {
      measurements: ['Waist', 'Length', 'Hip Width'], unit: 'inches',
      sizes: { 'Small': ['26-29','38','47'], 'Medium': ['30-33','39','49'], 'Large': ['34-36','40','51'], 'X-Large': ['37-39','41','53'], '2X-Large': ['40-42','41','55'] }
    },
    'Lux Heavyweight T-Shirt': {
      measurements: ['Chest', 'Length', 'Sleeve'], unit: 'inches',
      sizes: { 'Small': ['19','27','8.5'], 'Medium': ['21','28','8.8'], 'Large': ['23','29','9'], 'X-Large': ['25','30','9.3'], '2X-Large': ['27','31','9.5'] }
    },
    'Performance Tank Top': {
      measurements: ['Chest', 'Length'], unit: 'inches',
      sizes: { 'Small': ['38','26'], 'Medium': ['40','27'], 'Large': ['42','28'], 'X-Large': ['44','29'], '2X-Large': ['46','30'], '3X-Large': ['48','31'] }
    },
    'Basketball Jersey': {
      measurements: ['Chest', 'Length'], unit: 'inches',
      sizes: { 'Small': ['44','28'], 'Medium': ['46','29'], 'Large': ['48','30'], 'X-Large': ['50','31'], '2X-Large': ['52','32'] }
    },
    'Retro Soccer Jersey': {
      measurements: ['Chest', 'Length'], unit: 'inches',
      sizes: { 'Small': ['43','27.5'], 'Medium': ['44.5','28.5'], 'Large': ['46','29.5'], 'X-Large': ['48.5','30.5'], '2X-Large': ['50','31'], '3X-Large': ['52','32'] }
    },
    'Pajamas': {
      measurements: ['Waist', 'Length'], unit: 'inches',
      sizes: { 'X-Small': ['24-26','37'], 'Small': ['27-30','38'], 'Medium': ['31-34','39'], 'Large': ['35-38','40'], 'X-Large': ['39-41','41'], '2X-Large': ['42-45','42'] }
    },
    'Women Athletic Shorts': {
      measurements: ['Waist', 'Hip Width'], unit: 'inches',
      note: 'Fits smaller. Go a size above.', between: 'up',
      sizes: { 'X-Small': ['23-25','33-35'], 'Small': ['26-28','36-38'], 'Medium': ['29-31','39-41'], 'Large': ['32-34','42-44'], 'X-Large': ['35-37','45-47'] }
    },
    'Women Compression Shorts': {
      measurements: ['Waist', 'Length'], unit: 'inches',
      sizes: { 'Small': ['24','13'], 'Medium': ['25','13.5'], 'Large': ['26','14'], 'X-Large': ['26','14.5'], '2X-Large': ['28','15'] }
    },
    'Women Everyday Leggings': {
      measurements: ['Waist', 'Length'], unit: 'inches',
      sizes: { 'Small': ['24','38'], 'Medium': ['26','39'], 'Large': ['27','39.5'], 'X-Large': ['28','40'], '2X-Large': ['29','40.5'] }
    },
    'Women Sports Bra': {
      measurements: ['Chest', 'Length'], unit: 'inches',
      sizes: { 'Small': ['13','12'], 'Medium': ['14','12.5'], 'Large': ['15','13'], 'X-Large': ['16','13.5'], '2X-Large': ['17','14'] }
    },
    'Weight Lifting Lever Belt': {
      measurements: ['Waist', 'Length'], unit: 'inches',
      sizes: { 'Small': ['21-25','35'], 'Medium': ['25-30','39'], 'Large': ['31-35','43'], 'X-Large': ['36-40','47'] }
    }
  };

  // Types that borrow another type's chart (prompt 136: long sleeves use the jersey chart for now). Kept out of
  // sscSizeChartData so the size guide and help chips don't list them as their own type.
  var chartAlias = { 'Long Sleeve Jersey': 'Retro Soccer Jersey' };

  var sizeLabels = {
    'X-Small': 'XS', 'Small': 'S', 'Medium': 'M', 'Large': 'L',
    'X-Large': 'XL', '2X-Large': '2XL', '3X-Large': '3XL'
  };

  var howTo = {
    'Waist': ['waist', 'Relaxed, straight across the waistband, edge to edge. Double it for the full waist.'],
    'Inseam': ['inseam', 'Crotch seam down the inside leg to the hem.'],
    'Length': ['len', 'Top of the waistband down the side to the hem.'],
    'Outseam': ['len', 'Top of the waistband down the side to the hem.'],
    'Hip Width': ['hip', 'Straight across the widest part of the hips.'],
    'Leg Opening': ['leg', 'Across the bottom hem of one leg.']
  };

  function normalizeSize(s) {
    if (!s) return s;
    var map = {
      'x-small': 'X-Small', 'xs': 'X-Small',
      'small': 'Small', 's': 'Small',
      'medium': 'Medium', 'm': 'Medium',
      'large': 'Large', 'l': 'Large',
      'x-large': 'X-Large', 'xl': 'X-Large',
      '2x-large': '2X-Large', '2-x-large': '2X-Large', 'xxl': '2X-Large', '2xl': '2X-Large',
      '3x-large': '3X-Large', '3-x-large': '3X-Large', 'xxxl': '3X-Large', '3xl': '3X-Large'
    };
    return map[String(s).toLowerCase().trim()] || s;
  }

  function decodeValue(b64) {
    if (!b64) return '';
    try { return atob(b64).replace(/\+/g, ' '); } catch (e) { return ''; }
  }

  function readSelectedSize() {
    var btn = document.querySelector('.ssc-size.is-selected');
    if (btn) {
      var raw = (btn.getAttribute('data-label') || '').trim();
      return raw ? normalizeSize(raw) : null;
    }
    var sizeGroup = null;
    var labels = document.querySelectorAll('label[for*="-option"]');
    for (var i = 0; i < labels.length; i++) {
      var nameText = (labels[i].textContent || '').split(':')[0].trim().toLowerCase();
      if (nameText === 'size' || nameText.indexOf('size') === 0) {
        sizeGroup = labels[i].closest('.w-full');
        break;
      }
    }
    var scope = sizeGroup || document;
    var legacy = scope.querySelector('button.js-activeVariant.border--focus')
           || scope.querySelector('button.border--focus')
           || scope.querySelector('button.js-activeVariant');
    if (!legacy) return null;
    var span = legacy.querySelector('span');
    var rawLegacy = span ? (span.textContent || '').trim() : decodeValue(legacy.getAttribute('data-value'));
    if (!rawLegacy) rawLegacy = decodeValue(legacy.getAttribute('data-value'));
    return rawLegacy ? normalizeSize(rawLegacy) : null;
  }

  var currentOverlay = null;
  var returnFocus = null;
  var holdOthers = false;

  function unlockScroll() {
    var menu = document.querySelector('[data-ssc-menu]');
    if (menu && !menu.hidden) return;
    if (document.querySelector('dialog.quick-add-modal[open]')) return;
    if (document.querySelector('#cart-drawer[open], #cart-drawer dialog[open]')) return;
    document.documentElement.classList.remove('ssc-scroll-lock');
  }

  function focusOpener(node) {
    var target = node && node.isConnected ? node : null;
    if (!target) {
      var qa = document.querySelector('dialog.quick-add-modal[open]');
      target = qa && qa.querySelector('.ssc-sc-link');
    }
    if (target && target.focus) target.focus();
  }

  function closeModal(restore) {
    var dialog = currentOverlay;
    var back = returnFocus;
    currentOverlay = null;
    returnFocus = null;
    if (dialog) {
      if (dialog.open && dialog.close) dialog.close();
      dialog.remove();
    }
    unlockScroll();
    if (restore === false || !back) return;
    setTimeout(function () { focusOpener(back); }, 0);
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function conv(value, unit) {
    var raw = String(value);
    if (unit === 'in') return raw.replace('-', '–');
    return raw.split('-').map(function (part) {
      return String(Math.round(parseFloat(part) * 2.54));
    }).join('–');
  }

  function howSvg() {
    return '<svg viewBox="0 0 120 120" aria-hidden="true">' +
      '<path d="M22 18h76l8 78-34 6-12-46-12 46-34-6z" fill="var(--ssc-white)" stroke="currentColor" stroke-width="3" stroke-linejoin="round"/>' +
      '<path d="M22 18h76v12H22z" fill="currentColor"/>' +
      '<g data-m="waist"><path d="M22 10h76" stroke="var(--ssc-sfx)" stroke-width="2.5"/><path d="M22 6v8M98 6v8" stroke="var(--ssc-sfx)" stroke-width="2.5"/></g>' +
      '<g data-m="len"><path d="M112 18l4 80" stroke="var(--ssc-sfx)" stroke-width="2.5"/></g>' +
      '<g data-m="inseam"><path d="M60 58l-10 42" stroke="var(--ssc-sfx)" stroke-width="2.5" stroke-dasharray="4 3"/></g>' +
      '<g data-m="hip"><path d="M20 44h80" stroke="var(--ssc-sfx)" stroke-width="2.5" stroke-dasharray="4 3"/></g>' +
      '<g data-m="leg"><path d="M16 104l34 6" stroke="var(--ssc-sfx)" stroke-width="2.5"/></g>' +
      '</svg>';
  }

  function showSizeChart(productType, opener) {
    var trigger = opener && opener.classList && opener.classList.contains('ssc-sc-link')
      ? opener
      : document.activeElement;
    closeModal(false);
    if (!trigger || trigger === document.body || !trigger.classList || !trigger.classList.contains('ssc-sc-link')) {
      trigger = document.querySelector('dialog.quick-add-modal[open] .ssc-sc-link');
    }
    returnFocus = trigger && trigger.classList && trigger.classList.contains('ssc-sc-link') ? trigger : null;
    if (!productType) return;

    var chartData = window.sscSizeChartData[productType] || window.sscSizeChartData[chartAlias[productType]];
    var overlay = el('dialog', 'ssc-sc-dialog');
    overlay.setAttribute('aria-labelledby', 'ssc-sc-title');
    var sheet = el('div', 'ssc-sc-sheet');

    var head = el('div', 'ssc-sc-head');
    head.appendChild(el('div', 'ssc-sc-grab'));
    var bubble = el('span', 'ssc-sc-bub', productType);
    var title = el('h2', 'ssc-sc-title', 'Size chart');
    title.id = 'ssc-sc-title';
    var closeBtn = el('button', 'ssc-sc-x');
    closeBtn.type = 'button';
    closeBtn.setAttribute('aria-label', 'Close size chart');
    closeBtn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    closeBtn.addEventListener('click', closeModal);
    head.appendChild(bubble);
    head.appendChild(title);
    head.appendChild(closeBtn);
    sheet.appendChild(head);

    var body = el('div', 'ssc-sc-body');

    if (!chartData) {
      body.appendChild(el('p', 'ssc-sc-soon', 'Size chart coming soon'));
    } else {
      var keys = Object.keys(chartData.sizes);
      var picked = readSelectedSize();
      if (!picked || keys.indexOf(picked) < 0) {
        picked = keys.indexOf('Medium') >= 0 ? 'Medium' : keys[Math.floor((keys.length - 1) / 2)];
      }
      var unit = 'in';

      var ctrl = el('div', 'ssc-sc-ctrl');
      ctrl.appendChild(el('span', null, 'Pick a size'));
      var units = el('div', 'ssc-sc-unit');
      units.setAttribute('role', 'group');
      units.setAttribute('aria-label', 'Units');
      var inBtn = el('button', null, 'IN');
      var cmBtn = el('button', null, 'CM');
      inBtn.type = 'button';
      cmBtn.type = 'button';
      inBtn.setAttribute('aria-pressed', 'true');
      cmBtn.setAttribute('aria-pressed', 'false');
      units.appendChild(inBtn);
      units.appendChild(cmBtn);
      ctrl.appendChild(units);

      var pills = el('div', 'ssc-sc-pills');
      var you = el('div', 'ssc-sc-you');
      var youH = el('div', 'ssc-sc-you-h');
      youH.appendChild(el('span', null, 'Your size'));
      var youS = el('b');
      youH.appendChild(youS);
      var stats = el('div', 'ssc-sc-stats');
      you.appendChild(youH);
      you.appendChild(stats);

      var note = el('div', 'ssc-sc-narr');
      note.appendChild(el('b', null, 'Fit tip'));
      var noteText = el('span');
      note.appendChild(noteText);
      if (!chartData.note) note.hidden = true;

      var tableWrap = el('div', 'ssc-sc-table-wrap');
      var table = el('table', 'ssc-sc-table');
      tableWrap.appendChild(table);

      var howK = el('p', 'ssc-sc-how-k', 'How to measure');
      var how = el('div', 'ssc-sc-how');
      how.innerHTML = howSvg();
      var howList = el('ul');
      how.appendChild(howList);

      var foot = el('p', 'ssc-sc-foot');
      foot.appendChild(document.createTextNode('Still not sure? Email '));
      var mail = el('a', null, 'info@someslight.com');
      mail.href = 'mailto:info@someslight.com';
      foot.appendChild(mail);
      foot.appendChild(document.createTextNode(" and we'll size you."));
      var guide = el('a', 'ssc-sc-guide', 'Full size guide');
      guide.href = '/pages/size-guide?type=' + encodeURIComponent(chartAlias[productType] || productType);
      guide.appendChild(el('span', null, ' →')).setAttribute('aria-hidden', 'true');

      function paint() {
        var suffix = unit === 'in' ? '"' : ' cm';
        pills.replaceChildren();
        keys.forEach(function (key) {
          var pill = el('button', 'ssc-sc-pill', sizeLabels[key] || key);
          pill.type = 'button';
          pill.setAttribute('aria-label', key);
          pill.setAttribute('aria-pressed', key === picked ? 'true' : 'false');
          pill.addEventListener('click', function () {
            picked = key;
            paint();
          });
          pills.appendChild(pill);
        });
        youS.textContent = sizeLabels[picked] || picked;
        stats.replaceChildren();
        chartData.measurements.forEach(function (meas, index) {
          var stat = el('div', 'ssc-sc-stat');
          stat.appendChild(el('span', null, meas));
          var strong = el('strong');
          strong.appendChild(document.createTextNode(conv(chartData.sizes[picked][index], unit)));
          strong.appendChild(el('em', null, suffix));
          stat.appendChild(strong);
          stats.appendChild(stat);
        });
        note.hidden = !chartData.note;
        noteText.textContent = chartData.note || '';

        var si = keys.indexOf(picked);
        var thead = el('thead');
        var headRow = el('tr');
        var corner = el('th');
        var sr = el('span', 'ssc-sc-sr', 'Measurement');
        corner.appendChild(sr);
        headRow.appendChild(corner);
        keys.forEach(function (key, index) {
          var th = el('th', index === si ? 'ssc-sc-hl' : '', sizeLabels[key] || key);
          th.scope = 'col';
          headRow.appendChild(th);
        });
        thead.appendChild(headRow);

        var tbody = el('tbody');
        chartData.measurements.forEach(function (meas, mIdx) {
          var row = el('tr');
          var label = el('th', null, meas);
          label.scope = 'row';
          row.appendChild(label);
          keys.forEach(function (key, index) {
            var td = el('td', index === si ? 'ssc-sc-hl' : '', conv(chartData.sizes[key][mIdx], unit));
            row.appendChild(td);
          });
          tbody.appendChild(row);
        });
        table.replaceChildren(thead, tbody);

        how.querySelectorAll('[data-m]').forEach(function (node) { node.hidden = true; });
        howList.replaceChildren();
        chartData.measurements.forEach(function (meas) {
          var spec = howTo[meas];
          if (!spec) return;
          var mark = how.querySelector('[data-m="' + spec[0] + '"]');
          if (mark) mark.hidden = false;
          var li = el('li');
          li.appendChild(el('b', null, meas));
          li.appendChild(document.createTextNode(spec[1]));
          howList.appendChild(li);
        });
      }

      inBtn.addEventListener('click', function () {
        unit = 'in';
        inBtn.setAttribute('aria-pressed', 'true');
        cmBtn.setAttribute('aria-pressed', 'false');
        paint();
      });
      cmBtn.addEventListener('click', function () {
        unit = 'cm';
        cmBtn.setAttribute('aria-pressed', 'true');
        inBtn.setAttribute('aria-pressed', 'false');
        paint();
      });

      body.appendChild(ctrl);
      body.appendChild(pills);
      body.appendChild(you);
      body.appendChild(note);
      body.appendChild(tableWrap);
      body.appendChild(howK);
      body.appendChild(how);
      body.appendChild(guide);
      body.appendChild(foot);
      paint();
    }

    sheet.appendChild(body);
    overlay.appendChild(sheet);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });
    overlay.addEventListener('cancel', function (e) {
      e.preventDefault();
    });

    document.body.appendChild(overlay);
    currentOverlay = overlay;
    document.documentElement.classList.add('ssc-scroll-lock');
    overlay.showModal();
    closeBtn.focus();
  }

  window.sscSizeChart = { show: showSizeChart, close: closeModal, readSelectedSize: readSelectedSize };

  document.addEventListener('keydown', function (e) {
    if ((e.key !== 'Escape' && e.key !== 'Esc') || !currentOverlay || !currentOverlay.open) return;
    e.preventDefault();
    e.stopPropagation();
    holdOthers = true;
    closeModal();
    setTimeout(function () { holdOthers = false; }, 0);
  }, true);

  document.addEventListener('cancel', function (e) {
    if (!holdOthers && !(currentOverlay && currentOverlay.open)) return;
    if (e.target !== currentOverlay) e.preventDefault();
  }, true);

  document.addEventListener('close', function () {
    if (currentOverlay) return;
    unlockScroll();
  }, true);

  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('.ssc-sc-link') : null;
    if (!link) return;
    e.preventDefault();
    showSizeChart(link.getAttribute('data-product-type') || '', link);
  });
})();
